import React, { useState, useEffect } from 'react';
import './Navbar.css';
import { Menu, X } from 'lucide-react';

function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  return (
    <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
      <div className='navbar-container'>
        {/* Logo */}
        <div className='navbar-logo'>
          <span className='logo-text'>
            Re<span className='logo-highlight'>post</span>
          </span>
        </div>

        {/* Desktop Links */}
        <div className='navbar-links'>
          <button onClick={() => scrollToSection('video-demo')}>Demo</button>
          <button onClick={() => scrollToSection('demo')}>How It Works</button>
          <button onClick={() => scrollToSection('signup')} className='nav-cta'>
            Join Beta
          </button>
        </div>

        {/* Mobile Menu Toggle */}
        <button
          className='mobile-menu-toggle'
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label='Toggle menu'
        >
          {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className='mobile-menu'>
          <button onClick={() => scrollToSection('demo')}>Demo</button>
          <button onClick={() => scrollToSection('video-demo')}>
            How It Works
          </button>
          <button onClick={() => scrollToSection('signup')} className='nav-cta'>
            Join Beta
          </button>
        </div>
      )}
    </nav>
  );
}

export default Navbar;
